import { useTranslation } from "react-i18next";
import styles from './conditions.module.scss';

const StarIcon = () => (
    <svg className={styles.starIcon} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fillRule="evenodd" clipRule="evenodd" d="M11.5043 3.83685C11.6732 3.51898 12.1287 3.51897 12.2975 3.83684L14.3494 7.70021C14.5878 8.14908 15.0199 8.46289 15.5203 8.55088L19.8286 9.30854C20.1831 9.37087 20.3239 9.80402 20.0737 10.0628L17.0336 13.2082C16.6802 13.5736 16.5154 14.0815 16.5863 14.5845L17.1971 18.9162C17.2474 19.2726 16.8788 19.5403 16.5555 19.3824L12.6247 17.463C12.168 17.24 11.6339 17.2399 11.1772 17.463L7.24646 19.3824C6.923 19.5403 6.55453 19.2726 6.60478 18.9162L7.21559 14.5846C7.28654 14.0815 7.12161 13.5736 6.76841 13.2083L3.72815 10.0628C3.47802 9.80407 3.61875 9.37087 3.97324 9.30854L8.28167 8.55088C8.78213 8.46287 9.21408 8.14905 9.45244 7.70028L11.5043 3.83685ZM13.3573 3.27396C12.7373 2.1066 11.0646 2.1066 10.4445 3.27396L8.39264 7.1374C8.32774 7.25959 8.21011 7.34505 8.07384 7.36902L3.76542 8.12667C2.4636 8.35559 1.94668 9.94642 2.86532 10.8968L5.90558 14.0422C6.00165 14.1416 6.04667 14.28 6.02735 14.417L5.41654 18.7487C5.23197 20.0575 6.58525 21.0407 7.77298 20.4607L11.7039 18.5413C11.8282 18.4806 11.9736 18.4805 12.0978 18.5412L16.0289 20.4607C17.2166 21.0407 18.5699 20.0575 18.3854 18.7487L17.7745 14.417C17.7552 14.2799 17.8002 14.1416 17.8962 14.0423L20.9365 10.8968C21.8551 9.94647 21.3384 8.3556 20.0365 8.12667L15.7281 7.36902C15.5917 7.34504 15.4741 7.25955 15.4093 7.13746L13.3573 3.27396Z" fill="#2E86F9"/>
    </svg>
);

const CheckCircleIcon = () => (
    <svg className={styles.checkIcon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M8.79978 12.504L6.30378 10.008C6.21011 9.9143 6.09536 9.8643 5.95953 9.85797C5.82353 9.85147 5.70236 9.90147 5.59603 10.008C5.48953 10.1143 5.43628 10.2322 5.43628 10.3617C5.43628 10.4912 5.48953 10.6091 5.59603 10.7155L8.23453 13.354C8.39603 13.5155 8.58445 13.5962 8.79978 13.5962C9.01511 13.5962 9.20361 13.5155 9.36528 13.354L14.842 7.87722C14.9357 7.78355 14.9857 7.6688 14.992 7.53297C14.9985 7.39697 14.9485 7.2758 14.842 7.16947C14.7357 7.06297 14.6178 7.00972 14.4883 7.00972C14.3588 7.00972 14.2409 7.06297 14.1345 7.16947L8.79978 12.504ZM10.2415 19.0117C8.99703 19.0117 7.82695 18.7756 6.73128 18.3032C5.63578 17.8309 4.68278 17.1899 3.87228 16.3802C3.06178 15.5706 2.4202 14.6184 1.94753 13.5237C1.4747 12.4292 1.23828 11.2596 1.23828 10.015C1.23828 8.77047 1.47445 7.60039 1.94678 6.50472C2.41911 5.40922 3.06011 4.45622 3.86978 3.64572C4.67945 2.83522 5.63161 2.19364 6.72628 1.72097C7.82078 1.24814 8.99036 1.01172 10.235 1.01172C11.4795 1.01172 12.6496 1.24789 13.7453 1.72022C14.8408 2.19255 15.7938 2.83355 16.6043 3.64322C17.4148 4.45289 18.0564 5.40505 18.529 6.49972C19.0019 7.59422 19.2383 8.7638 19.2383 10.0085C19.2383 11.253 19.0021 12.4231 18.5298 13.5187C18.0574 14.6142 17.4164 15.5672 16.6068 16.3777C15.7971 17.1882 14.8449 17.8298 13.7503 18.3025C12.6558 18.7753 11.4862 19.0117 10.2415 19.0117ZM10.2383 18.0117C12.4716 18.0117 14.3633 17.2367 15.9133 15.6867C17.4633 14.1367 18.2383 12.2451 18.2383 10.0117C18.2383 7.77839 17.4633 5.88672 15.9133 4.33672C14.3633 2.78672 12.4716 2.01172 10.2383 2.01172C8.00495 2.01172 6.11328 2.78672 4.56328 4.33672C3.01328 5.88672 2.23828 7.77839 2.23828 10.0117C2.23828 12.2451 3.01328 14.1367 4.56328 15.6867C6.11328 17.2367 8.00495 18.0117 10.2383 18.0117Z" fill="#2E86F9"/>
    </svg>
);

const Conditions = () => {

    const { t } = useTranslation();

    const points = [
        t('first-point'),
        t('second-point'),
        t('third-point'),
        t('fourth-point'),
    ];

    const notes = [
        t('first-note'),
        t('second-note'),
        t('third-note'),
        t('fourth-note'),
        t('fifth-note'),
    ];

    return (
        <div className={styles.conditions}>
            <h2 className={styles.title}>{t('conditions-title')}</h2>

            <div className={styles.callout}>
                <StarIcon />
                <p>{t('bonus')}</p>
            </div>

            <ul className={styles.points}>
                {
                    points.map((point, i) => (
                        <li key={i}>
                            <CheckCircleIcon />
                            <span>{point}</span>
                        </li>
                    ))
                }
            </ul>

            <div className={styles.notes}>
                <h4>{t('notes-title')}</h4>
                <ul>
                    {notes.map((note, i) => <li key={i}>{note}</li>)}
                </ul>
            </div>
        </div>
    );
};

export default Conditions;
